import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../../Config'
import moment from "moment-timezone";
import * as Utils from "../../../inc/Utils";
import Select from 'react-select'
import DatePicker from "react-datepicker";

export default function CampaignTemplateCreatePromotion(props) {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false); 
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [campaignType, setCampaignType] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [buType, setBuType] = React.useState(null);
    let [buTypeId, setBuTypeId] = React.useState(null);
    let [campaignDate, setCampaignDate] = React.useState(null);
    let [campaign, setCampaign] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);

    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');

    let [disableCampaign, setDisableCampaign] = React.useState(true);
    let [agency, setAgency] = React.useState(null);

    let refUrl = React.useRef();

    React.useEffect(() => {
        setTypeId(props.typeId);

        (async function() {
            try {
                const resAgency = await Utils.getAgency();
                setAgency(resAgency);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);

                const resBuType = await Utils.getBuType();
                setBuType(resBuType);

                if(langId && langId.id && campaignTypeId && campaignTypeId.id && buTypeId && buTypeId.id) {
                    setCampaignPlaceholder('กำลังโหลด...');
                    const prom = await Utils.getPromotion({
                        langId: langId.id,
                        campaignTypeId: campaignTypeId.id,
                        buTypeId: buTypeId.id,
                        campaignDate: campaignDate
                    });
                    if (typeof prom !== 'undefined' && prom.data) {
                        setCampaign(prom.data);
                        setCampaignPlaceholder('Select...');
                        setDisableCampaign(false);
                    } else {
                        setCampaign(null);
                        setCampaignPlaceholder('ไม่พบข้อมูล..');
                        setDisableCampaign(true);
                    }
                }

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, [langId, campaignDate, campaignTypeId, buTypeId]);

    const onCreate = () => {
        let name = props.name;
        let url = refUrl.current.value;

        let items = [];
        if(roles.permissionId === Utils.SUPER_ADMIN_ID) {
            let checkboxes = document.getElementsByName('agencyIds[]');
            for (let i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked) {
                    items.push({'agencyId': checkboxes[i].value});
                }
            }
        }
        else {
            items.push({'agencyId': roles.agencyId});
        }

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Campaign Template");
        }
        else if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(!langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!campaignTypeId) {
            toast.error("กรุณาระบุ Campaign Type");
        }
        else if(!buTypeId) {
            toast.error("กรุณาระบุ Bu Type");
        }
        else if(!campaignId) {
            toast.error("กรุณาระบุ Promotion ID");
        }
        else if(!url) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else if(items.length <= 0) {
            toast.error("กรุณาระบุ Agency อย่างน้อย 1 รายการ");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                items: items,
                                name: name,
                                typeId: typeId ? typeId.id : null,
                                lang: langId ? langId.id : null,
                                campaignTypeId: campaignTypeId ? campaignTypeId.id : null,
                                buTypeId: buTypeId ? buTypeId.id : null,
                                campaignDate: campaignDate ? new Date(campaignDate) : null,
                                campaignId: campaignId ? campaignId.campaign_id : null,
                                url: url,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                                fetch(Config.url.API_URL +'/api/campaignTemplate/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/campaignTemplate', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = (obj) => {
        setLanguageId(obj);
        setCampaignTypeId(null);
        setBuTypeId(null);
        setCampaign(null);
        setCampaignId(null);
        refUrl.current.value = '';
    };

    const onChangeCampaignTypeId = (obj) => {
        setCampaignTypeId(obj);
        setBuTypeId(null);
        setCampaign(null);
        setCampaignId(null);
        refUrl.current.value = '';
    };

    const onChangeBuTypeId = (obj) => {
        setBuTypeId(obj);
        setCampaign(null);
        setCampaignId(null);
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
        refUrl.current.value = obj && obj.promotion_url? obj.promotion_url : '';
    };

    const onChangeCampaignDate = (value) => {
        setCampaignDate(value);
        setCampaign(null);
        setCampaignId(null);
    };

    return (
        <>
            <div className="col-12">
                <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={lang}
                    onChange={(event) => onChangeLanguageId(event)}
                    value={langId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="campaignTypeId" className="form-label">Campaign Type <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={campaignType}
                    onChange={(event) => onChangeCampaignTypeId(event)}
                    value={campaignTypeId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="buTypeId" className="form-label">BU Type <span className="text-danger">*</span></label>
                <Select
                    classNamePrefix="form-select-search"
                    options={buType}
                    onChange={(event) => onChangeBuTypeId(event)}
                    value={buTypeId}
                    getOptionValue={(option) => `${option.id}`}
                    getOptionLabel={(option) => `${option.name}`}
                />
            </div>
            <div className={campaignTypeId ? 'col-12':'d-none'}>
                <label htmlFor="campaignDate" className="form-label">Campaign Date <span className="text-danger d-none">*</span></label>
                <DatePicker
                    selected={campaignDate}
                    onChange={(date) => onChangeCampaignDate(date)}
                    dateFormat="yyyy-MM-dd"
                    wrapperClassName="w-100"
                    className="form-control w-100" />
            </div>
            <div className={campaignTypeId ? 'col-12':'d-none'}>
                <label htmlFor="campaignId" className="form-label">Promotion ID <span className="text-danger">*</span></label>
                <Select
                    isDisabled={disableCampaign}
                    classNamePrefix="form-select-search"
                    placeholder={campaignPlaceholder}
                    options={campaign}
                    onChange={(event) => onChangeCampaignId(event)}
                    value={campaignId}
                    getOptionValue={(option) => `${option.promotion_url}`}
                    getOptionLabel={(option) => `${option.campaign_id} : ${option.promotion_name} : ${option.project_type_slug}`}
                />
            </div>
            <div className="col-12">
                <label htmlFor="url" className="form-label">URL <span className="text-danger">*</span></label>
                <textarea className="form-control" id="url" ref={refUrl} rows={5} disabled={true}></textarea>
            </div>
            <div className={"col-12" + (roles.permissionId === Utils.SUPER_ADMIN_ID ? '':' d-none')}>
                <label htmlFor="agencyx" className="form-label">Agency</label>
                {
                    agency === null || agency.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                        agency.map((row, index) => {
                            let chkId = 'agencyCheck' + row.id;
                            return (
                                <div key={index} className="form-check ms-2">
                                    <input className="form-check-input" name="agencyIds[]" type="checkbox" value={row.id} id={chkId} />
                                    <label className="form-check-label" htmlFor={chkId}>
                                        {row.name} {row.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                    </label>
                                </div>);
                        })
                }
            </div>

            <div className="col-12">
                <label htmlFor="statusx" className="form-label">สถานะ</label>
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                    <label className="form-check-label" htmlFor="status"></label>
                </div>
            </div>
            <div className="col-12">
                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading}><span
                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                <NavLink className="btn btn-sm btn-light ms-2" to='/campaignTemplate'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                <Toaster position="bottom-right" />
            </div>
        </>
    );
} 